/*
####  ##    ##   ########    #######   
 ##   ###   ##   ##         ##     ##  
 ##   ####  ##   ##         ##     ##  
 ##   ## ## ##   ######     ##     ##  
 ##   ##  ####   ##         ##     ##  
 ##   ##   ###   ##         ##     ##  
####  ##    ##   ##          #######   
*/

/*	A priori, les fonctions de ce fichiers n'ont pas besoin d’être
	modifiées.
	Seul cas particulier : vous voiulez réalisé des animations JS 
	de révélation spécifiques. Normalement la plupart des cas devraient
	etre couvert avec les classes "sr sr--add-class" et "sr--item".
	Voir la documentation au niveau de la partie SCROLL REVEAL plus bas.
*/


/*
 ######     #######   ##    ##    ######     #######   ##         ########   
##    ##   ##     ##  ###   ##   ##    ##   ##     ##  ##         ##         
##         ##     ##  ####  ##   ##         ##     ##  ##         ##         
##         ##     ##  ## ## ##    ######    ##     ##  ##         ######     
##         ##     ##  ##  ####         ##   ##     ##  ##         ##         
##    ##   ##     ##  ##   ###   ##    ##   ##     ##  ##         ##         
 ######     #######   ##    ##    ######     #######   ########   ########   
*/

/*	Permet l'ajout de 2 paramètres à la fonction console.log():
	- $bg : couleur de fond du message
	- $color : couleur du texte du message
*/	
(function () {
	consoleLog = function ($message, $bg, $color) {
		console.log('%c' + $message, 'background-color:' + $bg + '; color:' + $color + ';padding:3px 5px;');
	};
})();

// /*	Affiche un message personnalisé dans la console */
consoleLog(' ');
consoleLog('Fabriqué à Lyon par Mcube','#231D34','#ffffff');
consoleLog('www.mcube.fr','#FA3348','#ffffff');
consoleLog(' ');


/*
 ######     #######   ##    ##   ########   
##    ##   ##     ##  ###   ##   ##         
##         ##     ##  ####  ##   ##         
##         ##     ##  ## ## ##   ######     
##         ##     ##  ##  ####   ##         
##    ##   ##     ##  ##   ###   ##         
 ######     #######   ##    ##   ##         
*/

/*	A ne pas modifier. Ces variables peuvent être redéfinies 
	dans le fichier zz-mcube.js
*/
var currentURL         = window.location.href;
var pageTransition     = false;
var showLoader         = null;
var pageAjax           = false;
var parallaxBreakpoint = 768;



/*
########   ########   ########    #######   ##     ##  ##    ##    ######    ########   
##     ##  ##         ##     ##  ##     ##  ##     ##  ###   ##   ##    ##   ##         
##     ##  ##         ##     ##  ##     ##  ##     ##  ####  ##   ##         ##         
##     ##  ######     ########   ##     ##  ##     ##  ## ## ##   ##         ######     
##     ##  ##         ##     ##  ##     ##  ##     ##  ##  ####   ##         ##         
##     ##  ##         ##     ##  ##     ##  ##     ##  ##   ###   ##    ##   ##         
########   ########   ########    #######    #######   ##    ##    ######    ########   
*/

/*	Debounce permet d’optimiser la gestion des évènements que l’on
	souhaite déclencher au resize du viewport.
	Voir la section Resize Handler dans le fichier zz-mcube.js
*/
var debounce = function( wait, immediate, func ) {
	var timeout;

	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};


var addEndEvent = debounce( 200, false, function(e) {
	jQuery(this).trigger(e.type + 'End');
});



/*
##         ####  ##    ##   ##    ##   
##          ##   ###   ##   ##   ##    
##          ##   ####  ##   ##  ##     
##          ##   ## ## ##   #####      
##          ##   ##  ####   ##  ##     
##          ##   ##   ###   ##   ##    
########   ####  ##    ##   ##    ##   

##     ##     ###     ##    ##   ########   ##         ########   ########   
##     ##    ## ##    ###   ##   ##     ##  ##         ##         ##     ##  
##     ##   ##   ##   ####  ##   ##     ##  ##         ##         ##     ##  
#########  ##     ##  ## ## ##   ##     ##  ##         ######     ########   
##     ##  #########  ##  ####   ##     ##  ##         ##         ##   ##    
##     ##  ##     ##  ##   ###   ##     ##  ##         ##         ##    ##   
##     ##  ##     ##  ##    ##   ########   ########   ########   ##     ##  
*/

/*	Intercepte les clics sur les balises "a" et les tags 
	contenant l’attribut "data-link".
	Suivant le réglage de la variable "pageTransition"
	traite l'action directement ou transmet l’url à la fonction
	showLoader() pour initier une animation de transition de page
*/
var linkHandler = function(element) {
	var $link = element;
	var url  = ( $link.attr('href') || $link.attr('data-link'));
	
	if ( $link.hasClass('no-link') ||
		url.match('^#') ) {
		return;
	}

	if( $link.attr('target') == "_blank" ){
		window.open( url , "_blank");
		return;
	}

	if (url === currentURL)
		return;

	// Annule l'action du lien en cas de chargement via AJAX
	if( pageAjax && $link.attr('rel') ){
		return;
	}

	// On envoi l’URL vers le loader s'il y a un loader
	if( pageTransition ){
		showLoader( url );
		return;
	}

	// Ou on joue une simple redirection
	window.location.href = url;
};

/*
   ###           ##      ###     ##     ##  
  ## ##          ##     ## ##     ##   ##   
 ##   ##         ##    ##   ##     ## ##    
##     ##        ##   ##     ##     ###     
#########  ##    ##   #########    ## ##    
##     ##  ##    ##   ##     ##   ##   ##   
##     ##   ######    ##     ##  ##     ##  
*/

function ajaxUrl(){

	var template_actuel = jQuery('body').data('template');
	var element_click   = "";
	var current_post    = null;
	var ajax_init       = true;

	jQuery.address.state('/').init(function() {
        
    }).change(function(event) {

		if( ajax_init ){
			jQuery('body').imagesLoaded({ background: true })
			.done( function(instance) {
				switch_after_ajax();
			});
			ajax_init = false;
			return;
		}

	    switch_before_ajax( event.path );

    });


    function bindAddress(){

		jQuery('a[rel="address"]').unbind('click').click(function(e) { 
			e.preventDefault();
			value         = jQuery(this).attr('href').replace(/^#/, '');
			jQuery('a[rel="address"]').removeClass('ajax-current');
			jQuery(this).addClass('ajax-current');
		    jQuery.address.value(value);
		});

    }

	function perform_ajax_request( url ) {
	    jQuery.ajax({
	        url    : url,
	        type   : 'POST',
	        headers: {
	            'X-Requested-With':'XMLHttpRequest'
	        }
	    }).done( function( data ) {
	        /* Traitement JSON */
	        var retour = jQuery.parseJSON( data );
	        switch_ajax_content( retour );
	    }).error( function() {
	        // Error
	        alert( 'Impossible de mettre à jour le contenu' );
	    });
	}

	// la fonction avant bascule des contenus
	function switch_before_ajax(){
		switch( template_actuel ) {
	        case 'exemple':
	        	jQuery.fn.initBeforeExemple();
	            break;
	        default :
	        	jQuery('body').removeClass('is-loaded');
	        	break;
	    }
	    setTimeout(function(){
	    	perform_ajax_request( url );
	    }, 500);
	}

	// la fonction après bascule des contenus
	function switch_after_ajax(){
		
		switch( template_actuel ) {
	        case 'exemple':
	        	jQuery.fn.initAfterExemple();
	            break;
	        default :
	    		jQuery('body').addClass('is-loaded');
	        	break;
	    }

	    bindAddress();

	}

	// la fonction pour la bascule des contenus
	function switch_ajax_content( data ) {

		// mise à jour du template
	    template_actuel = data.template;

		// functions exécutées pendant le changement de contenu
	    switch( template_actuel ) {
	        case 'exemple':
	            break;
	        default :
	        	// exemple par défaut
	        	//-> vide le div dans lequel je veux afficher le nouveau contenu
	    		jQuery('.ajax-main-content').html("");
	        	break;
	    }

	    switch( data.template ) {
	        case 'exemple':
	            break;
	        default :
	        	// exemple par défaut
	        	//-> je charge le nouveau contenu dans le div approprié
	            jQuery('.ajax-main-content').append( jQuery(data.content) );
	            jQuery('.ajax-container').imagesLoaded( { background: true })
				.always( function(instance) {
			    	switch_after_ajax();
				});
	        	break;
	    }

	    // changement du nom de l'onglet
	    jQuery.address.title(data.title);
	}

}

(function($){
	
	/**
	 ** Functions a exécuter avant ou après ajax
	**/
	$.fn.initBeforeExemple = function (){
		console.log(' Init exemple ');
	}
	$.fn.initAfterExemple = function (){
		console.log(' Init exemple ');
	}

})(jQuery);

/*
 ######    ########   ########   
##    ##   ##         ##    ##   
##         ##             ##     
##         ######        ##      
##         ##           ##       
##    ##   ##           ##       
 ######    ##           ##       
*/

/*	Autorise l'affiche d'un spinner plus élégant lors de la validation
	d'un formaulaire Contact Form 7
*/
var formLoader = function(){

	// Show new spinner on submit
	jQuery('.wpcf7-submit').on('click', function () {
		jQuery('<div class="ajax-form-loader"></div>').appendTo(".wpcf7");
		jQuery('.ajax-form-loader').addClass('visible');
	});

	// Hide new spinner on result
	jQuery('div.wpcf7').on('wpcf7:invalid wpcf7:spam wpcf7:mailsent wpcf7:mailfailed', function () {
		jQuery('.ajax-form-loader').removeClass('visible').remove();
	});

	jQuery('.form input, .form textarea').each(function(){
		jQuery(this).on('focus', function(){
			jQuery(this).closest('li').addClass('active');
		}).on('blur', function(){
			if( jQuery(this).val() === "" )
				jQuery(this).closest('li').removeClass('active');
		});
	});

};





/*
########      ###     ########      ###     ##         ##            ###     ##     ##  
##     ##    ## ##    ##     ##    ## ##    ##         ##           ## ##     ##   ##   
##     ##   ##   ##   ##     ##   ##   ##   ##         ##          ##   ##     ## ##    
########   ##     ##  ########   ##     ##  ##         ##         ##     ##     ###     
##         #########  ##   ##    #########  ##         ##         #########    ## ##    
##         ##     ##  ##    ##   ##     ##  ##         ##         ##     ##   ##   ##   
##         ##     ##  ##     ##  ##     ##  ########   ########   ##     ##  ##     ##  
*/

/*	Permet l’ajout rapide d’effets parallax sur n'importe quel bloc.
	L’animation se joue obligatoirement sur la hauteur complète du viewport.
	Les réglages sont recalculés après chaque resize du viewport.
	
	Utilisation : 
	- Ajouter la classe "parallax" à l’élément que l’on souhaite animer
	- Tous les autres attributs sont facultatifs
	- data-direction : défini l’orientation de l’animation. Défaut : 'vertical'
	- data-start : l’offset au départ de l’animation. en pixels ou %. Defaut : 0
	- data-end : l’offset à la fin de l’animation. en pixels ou %. Defaut : 0

	Il est possible de définir le breakpoint à partir duquel ce déclenche les animations.
	Ce réglage (via la variable "parallaxBreakpoint") est modifiable dans la section CONF 
	du fichier zz-mcube.js
*/

var ctrlParallax;
var sceneParallax = [];
var initParallax = function() {

	if ( jQuery(window).width() > parallaxBreakpoint ) {
		ctrlParallax = new ScrollMagic.Controller();
		jQuery('body').addClass('ctrlParallax');
	}

	jQuery('.parallax').each(function( index ) {
		jQuery(this).css({ transform: '' });
		
		if ( jQuery(window).width() > parallaxBreakpoint ) {
			var start      = jQuery(this).attr( 'data-start' );
			var end        = jQuery(this).attr( 'data-end' );
			var direction  = jQuery(this).attr( 'data-direction' );
			if ( start     === undefined ) start = 0;
			if ( end       === undefined ) end = 0;
			if ( direction === undefined ) direction = "vertical";

			var windowHeight  = jQuery(window).height();
			var elementOffset = jQuery(this).offset().top;
			var elementHeight = jQuery(this).outerHeight();
			var offset        = ( elementOffset - windowHeight );
			
			var tween;
			if ( direction == 'horizontal' ) {
				tween = TweenMax.fromTo( this, 1, { x: start }, { x: end, ease: Power0.easeNone } );
			} else {
				tween = TweenMax.fromTo( this, 1, { y: start }, { y: end, ease: Power0.easeNone } );
			}
			
			sceneParallax[index] = new ScrollMagic.Scene({
				offset: offset,
				triggerHook: 'onEnter'
			})
			.setTween( tween )
			.addTo( ctrlParallax );
		}
	});
};

var resizeParallax = function() {
	if ( jQuery(window).width() > parallaxBreakpoint )  {
		if ( ! jQuery('body').hasClass('ctrlParallax') ) {
			initParallax();
		} else {
			ctrlParallax.enabled(true);
			ctrlParallax.update(true);
		}
	} else {
		if ( jQuery('body').hasClass('ctrlParallax') ) {
			jQuery('body').removeClass('ctrlParallax');
			ctrlParallax.destroy(true);
		}
	}

	if ( jQuery(window).width() > parallaxBreakpoint ) {
		if ( ctrlParallax.enabled() ) {
			jQuery('.parallax').each(function( index ) {
			
				var elementDuration  = jQuery(this).attr( 'data-duration' );
				if ( elementDuration === undefined ) elementDuration = 1;

				var windowHeight  = jQuery(window).height();
				var elementOffset = jQuery(this).offset().top;
				var elementHeight = jQuery(this).outerHeight();
				var offset        = ( elementOffset - windowHeight );
				var duration      = ( windowHeight  + elementHeight );

				sceneParallax[index].duration(duration);
				sceneParallax[index].offset(offset);
				sceneParallax[index].update(true);
			}); 
		} 
	} else {
		jQuery('.parallax').each(function( index ) {
			jQuery(this).css({ transform: '' });
		});
	}	
};




/*
 ######     ######    ########    #######   ##         ##         
##    ##   ##    ##   ##     ##  ##     ##  ##         ##         
##         ##         ##     ##  ##     ##  ##         ##         
 ######    ##         ########   ##     ##  ##         ##         
      ##   ##         ##   ##    ##     ##  ##         ##         
##    ##   ##    ##   ##    ##   ##     ##  ##         ##         
 ######     ######    ##     ##   #######   ########   ########   

########   ########   ##     ##  ########      ###     ##         
##     ##  ##         ##     ##  ##           ## ##    ##         
##     ##  ##         ##     ##  ##          ##   ##   ##         
########   ######     ##     ##  ######     ##     ##  ##         
##   ##    ##          ##   ##   ##         #########  ##         
##    ##   ##           ## ##    ##         ##     ##  ##         
##     ##  ########      ###     ########   ##     ##  ########   
*/

var initScrollAnimations = function() {
	var controllerScroll = new ScrollMagic.Controller();

	jQuery('.sr').each(function() {
		var element = jQuery(this);
		var offset  = element.offset().top;
		var windowHeight  = jQuery(window).height();
		var scene   = new ScrollMagic.Scene({
			triggerHook: "onLeave",
			offset: offset - ( windowHeight * 0.85 ),
			reverse: false
		});
		scene.on('start', function(e) {
			if (e.scrollDirection != 'REVERSE') {
				element.trigger('reveal');
				scene.remove();
			}
		});
		scene.addTo(controllerScroll);
	});	
	jQuery('.page-container').data('scrollController', controllerScroll);
};


/*	Zone "potentiellement" éditable

	Pour l'utilisation :
	- Ajouter la classe "sr" au bloc que vous souhaitez révéler
	- Ajouter une classe complémentaire pour utiliser une des aniomations prédéfinies
		
		- "sr--word" : pour réveler un texte sur une seule ligne. Il faut également
		imbriquer le texte dans un span
		exemple. <h2 class="sr sr--word"><span>Mon texte</span></h2>
		
		- "sr--line" : anime toutes les lignes des éléments P inclus
		
		- "sr--add-class" : ajoute une classe à tous les sous-éléments taggués
		avec la classe "sr--item". Vous pouvez ensuite effectuer les réglages suivants
		à l'aide d’attributs sur le bloc "sr--add-class" :
			- "data-class" : le nom de la classe ajoutée à chaque élément "sr--item".
			  Défaut : "sr--show"
			- "data-duration" : entre 0 et 1. Défini la zone de déclenchement. Défaut : 0.5
			- "data-delay" : en secondes. Défini le délai d'ajout de la classe sur chaque itération
			  des éléments "sr--item"
*/

var scrollRevealHandler = function() {
	var element = jQuery(this);

	if (element.hasClass('is-revealed'))
		return;

	if (element.is('.sr--word')) {
		splitTitle = new SplitText(element.find('span'),{
			type:       'words',
			wordsClass: 'split-word'
		});

		lines = element.find('span');
		words = element.find('.split-word');

		words.css({
			opacity: 0
		});
		element.find('span').css({
			opacity: 1
		});

		element.addClass('is-revealed');

		tl = new TimelineLite();
		tl.pause();

		lines.each(function(index) {
			var line = jQuery(this);
			tl.fromTo(line.find('.split-word'), 0.8, {
				alpha: 0,
				top: line.height()
			}, {
				alpha: 1,
				top: 0,
				ease: Power3.easeInOut
			}, 0 + (index * 0.1));
		});
		tl.call(function() {
			splitTitle.revert();
		});
		tl.play();


	} else if (element.is('.sr--line')) {

		splitTitle = new SplitText(element.find('p'),{
			type:       'lines',
			linesClass: 'split-line'
		});

		lines = element.find('.split-line');

		lines.css({
			opacity: 0
		});
		element.find('p').css({
			opacity: 1
		});

		element.addClass('is-revealed');

		tl = new TimelineLite();
		tl.pause();

		lines.each(function(index) {
			var line = jQuery(this);
			tl.fromTo( line, 0.8, {
				alpha: 0,
				top: 80,
			}, {
				alpha: 1,
				top: 0,
				ease: Power3.easeOut
			}, 0 + (index * 0.2));
		});
		tl.call(function() {
			splitTitle.revert();
		});
		tl.play();

	} else if (element.is('.editor-text')) {
		p = jQuery(this).find('p, li');
				
		element.addClass('is-revealed');

		p.css({
			opacity: 0
		});

		tl = new TimelineLite();
		tl.pause();
		
		p.each(function(index) {
			tl.fromTo(jQuery(this), 0.8, {
				alpha: 0,
				y: 20
			}, {
				alpha: 1,
				y: 0,
				ease: Power3.easeOut
			}, 0 + (index * 0.1));
		});
		tl.play();

	} else if (element.is('.sr--add-class')) {
		element.addClass('is-revealed');

		item = jQuery(this).find('.sr--item');

		var duration       = ( element.data('duration') || 0.5 );
		var delay          = ( element.data('delay') || 0.2 );
		var animationClass = ( element.data('class') || 'sr--show' );

		TweenMax.staggerTo(item, duration, {className: '+=' + animationClass}, delay);

	} else if (element.is('.text-appear')) {
		element.addClass('text-appear--visible');
	}
};